import * as React from "react";
import {authorize, IWithRouterProps, withRouter} from "@athena-portal/components";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {ButtonLink} from "../../../../../components/navigation/ButtonLink";
import {setSessionStorage} from "../../../../../CommonFunctions";
import {
    CLAIM_TYPE_MOTOR,
    CLAIM_TYPE_OTHER,
    Policy,
    ProductsEnum,
} from "@ferry/journey-services";
import {lazyInject} from "@athena-portal/core";
import {Types} from "../../../../../Types";
import type {ICustomerPortalService} from "../../../../../services/ICustomerPortalService";
import {InfoBanner, FalconNavigatorHeader, Footer} from "@ferry/portal-core";

interface IParams {
    policyNumber: string;
    [key: string]: string | undefined
}

interface IState {
    link: string,
    claimTypeChecked: string,
    policy?: Policy;
}

@authorize
export class PickMotorClaimKindPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {
    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    private claimTypes = new Map<string,string>([
        [CLAIM_TYPE_MOTOR,"Windscreen or window claim"],
        [CLAIM_TYPE_OTHER,"All other claims (road traffic accident, theft, misfuelling, stolen or lost keys, etc)"]
    ]);

    constructor(props: IWithRouterProps<IParams>) {
        super(props);

        this.state = {
            link: "",
            claimTypeChecked: "",
        };
    }

    public componentDidMount(): void {
        window.scrollTo(0, 0);
        const policyNumber: string = this.props.params.policyNumber;
        this.pluginTemplates.setPageTitle("Make a car claim");

        this.customerPortalService.getPolicy(policyNumber).subscribe((policy: Policy) => {
            this.setState({
                        policy
            });
        });
    }

    public render() {
        return (
            <React.Fragment>

                <FalconHeader/>
                <div className="plugin claims">
                    <FalconNavigatorHeader
                        back={this.getBackUrl()}
                        title="Make a car claim"
                    />
                    <div>
                        <div className="page-contents">
                            <InfoBanner wording={<>Your claim will be handled by Allianz</>}/>
                            {this.renderClaimRadioButtons(this.claimTypes)}
                        </div>
                        <div className="px-4 px-md-0 ml-md-19 padding-0">
                            <ButtonLink to={this.state.link} primary={true} routeState={{prevPath: location.pathname, product: this.state.policy?.products[0]}}
                                        disabled={this.state.link === ""} className={"float-right-desktop"}> Next </ButtonLink>
                        </div>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, this.getBackUrl())}
                </div>
                <Footer/>

            </React.Fragment>
        );
    }

    private handleOnChangeEvent = (event: any): void => {
        const value = event.currentTarget.value;

        if(this.claimTypes.has(value)) {
            this.setState({
                claimTypeChecked: value,
                link: `/dashboard/motorWindscreenOrOtherPage/${this.props.params.policyNumber}`
            });
                setSessionStorage("claim", value);

        }
    };

    private renderClaimRadioButtons(claimTypes: Map<string,string>) {

        const radioButtons: React.ReactNode[] = [];
        claimTypes.forEach((value,key)=>
        radioButtons.push(
            <div key={key} className="custom-control mt-2 ml-2 mb-3">
                <input
                    className={"custom-radiobutton cursor-pointer"}
                    type="radio"
                    name={key + "-claim"}
                    id={key + "-claim"}
                    value={key}
                    checked={this.state.claimTypeChecked === key}
                    onChange={this.handleOnChangeEvent}
                />
                <label id={'claim-type-label'} className="checkbox-label label-bg-transparent"
                       htmlFor={key + "-claim"}>
                    {value}
                </label>
            </div>)
        );
        return (
            <div className="panel margin-top-30 padding-top-10">
                <p className="font-weight-semi-bold">Please choose what type of claim you want to make?</p>
                <div>{radioButtons}</div>
            </div>
        );
    }

    private getBackUrl(): string
    {
        const {policy} = this.state;

        if (!policy) {
            return "/dashboard";
        }

        if (policy.interaction.product === ProductsEnum.DRIVE_AWAY) {
            return `/dashboard/driveAway/${policy.policyNumber}`;
        } else {
            return `/dashboard/annualMotor/${policy.policyNumber}`;
        }
    }
}

export const PickMotorClaimKindPage = withRouter<{}, IParams>(PickMotorClaimKindPagePlain)
